module.exports = __webpack_public_path__ + "img/pro_ar_06.80a0e0e9.jpg";